var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.data.examConfig.iconUrl)
          }),
          _vm._v(" "),
          _c("div", { staticClass: "txt" }, [
            _c("h2", [_vm._v(_vm._s(_vm.data.examConfig.name))]),
            _vm._v(" "),
            _c("p", [_vm._v("您已通过考核，请联系老师了解接下来的安排")]),
            _vm._v(" "),
            _vm.data.examState == "WaitingRegister"
              ? _c("div", { staticClass: "join" }, [_vm._v("报名未开始")])
              : _vm.data.examState == "WaitingCheckState"
              ? _c("div", { staticClass: "join" }, [_vm._v("已报名，等待审核")])
              : _vm.data.examState == "GoRegister"
              ? _c(
                  "div",
                  {
                    staticClass: "join",
                    on: {
                      click: function($event) {
                        return _vm.toRegister(_vm.data.examConfigId)
                      }
                    }
                  },
                  [_vm._v("立即报名")]
                )
              : _vm.data.examState == "UnRegister"
              ? _c("div", { staticClass: "join" }, [_vm._v("报名已结束")])
              : _vm.data.examState == "WaitingExam"
              ? _c("div", { staticClass: "join" }, [
                  _vm._v(_vm._s(_vm.data.examTypeName) + "未开始")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("考试须知")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _vm.data.examConfig.description != ""
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.examConfig.description)
                  }
                })
              : _c("p", [_vm._v("自定义")])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("考试详情")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "present", attrs: { id: "present" } }, [
      _c("ul", [
        _c("li", [_vm._v("考试类型：淘金大学（语音）本科考核")]),
        _vm._v(" "),
        _c("li", [_vm._v("考试总分：100分")]),
        _vm._v(" "),
        _c("li", [_vm._v("笔试占比：35%")]),
        _vm._v(" "),
        _c("li", [_vm._v("考试时长：560分钟")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a44307b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a44307b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/examDetailTemp.vue
// module id = 1129
// module chunks = 0